module.exports = __webpack_public_path__ + "img/status-false.6b61f1cd.svg";